import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    spacingContainer: {
      [breakpoints.down('md')]: {
        padding: '0px 8px 0px 9px',
      },
      [breakpoints.down(281)]: {
        padding: '0px 8px 85px 8px',
      },
    },
    descriptionButtonsContainer: {
      marginTop: 5,
    },
    login: {
      marginBottom: 8,

      '& b': {
        fontWeight: 'bold',
      },
    },
    subtitleLogin: {
      marginBottom: 16,
      fontSize: 14,
    },
    listRestrictions: {
      listStyle: 'none',
      padding: 0,
      margin: '0 0 24px 8px',

      '& li': {
        marginBottom: 5,
        fontFamily: 'Roboto',
        fontSize: 12,
        color: palette.gray,
        [breakpoints.down(960)]: {
          color: palette.white,
        },

        '&:before': {
          content: '"•"',
          marginRight: 5,
        },

        '&.valid': {
          color: palette.passwordBlue,
          [breakpoints.down(960)]: {
            color: palette.navSuperAdmin,
            fontWeight: 500,
          },

          '&:before': {
            content: '"✓"',
          },
        },
      },
    },
    password: {
      '& .MuiOutlinedInput-root': {
        height: 45,
        width: 340,
        borderColor: `${palette.darkGray} !important`,

        [breakpoints.down('md')]: {
          width: 310,
        },
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },

      '& .MuiSvgIcon-root': {
        height: 16,
        width: 16,
      },
      '& .MuiFormControl-fullWidth': {
        width: 'auto',
      },
      '& .MuiFormLabel-root': {
        color: `${palette.darkGray} !important`,
        [breakpoints.down(960)]: {
          borderColor: `${palette.white} !important`,
          color: `${palette.white} !important`,
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        [breakpoints.down(960)]: {
          borderColor: `${palette.white} !important`,
          color: `${palette.white} !important`,
        },
      },
      '& .MuiInputBase-root': {
        [breakpoints.down(960)]: {
          color: `${palette.white} !important`,
        },
      },
    },
    forgotPasswordLinkText: {
      fontSize: 12,
      fontWeight: 500,
    },
    forgotPasswordLinkContainer: { textAlign: 'right', marginTop: 12 },
    forgotPasswordContainer: { marginBottom: 12, padding: '0 35px' },
    loginButton: {
      backgroundColor: palette.navSuperAdmin,
      color: palette.white,
      height: 45,
      fontSize: 12,
      width: '85%',
      '&:hover': {
        backgroundColor: palette.navSuperAdmin,
        color: palette.white,
      },
    },
    newPassword: {
      [breakpoints.down('md')]: {
        marginBottom: 210,
      },
    },
    text: { fontSize: 35 },
  });
